var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comparison-gallery"},[_vm._l((_vm.comparisons),function(compare){return [_c('comparison-description',{key:compare.compare_id + '-description',attrs:{"info":compare}}),_c('comparison-card',{key:compare.compare_id,attrs:{"compare":compare},on:{"removeCompare":_vm.removeCompare}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }